import * as React from 'react';

export type FormDirection = 'horizontal' | 'vertical';

export const FormDirectionContext = React.createContext<FormDirection>('horizontal');

export type FormProps = {
    children?: React.ReactNode;
    isValid: boolean;
    onSubmit?: () => void;
    direction?: FormDirection;
};

export const SimpleForm: React.FunctionComponent<FormProps> = ({
    children,
    direction = 'vertical',
    isValid,
    onSubmit,
}) => {
    const submitHandler = (event: React.SyntheticEvent) => {
        event.preventDefault();
        if (isValid) {
            onSubmit?.();
        }
    };
    return (
        <form className={direction === 'vertical' ? 'form' : 'form-horizontal'} onSubmit={submitHandler}>
            {children}
        </form>
    );
};

SimpleForm.displayName = 'SimpleForm';
